import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link, Typography } from "@mui/material";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { useCreateAndAddExternalUserToTeam, useRetrieveTeam, useRetrieveUserTeamPermissions, } from "../ApiProvider";
import { ErrorView } from "../nav/Error";
import { Forbidden } from "../nav/Forbidden";
import { Loading } from "../nav/Loading";
import { useNumericParams } from "../utils/useNumericParams";
import { DEFAULT_PLAYER_METADATA, OfflinePlayerForm, } from "./OfflinePlayerForm";
const policyNotice = (_jsxs(Typography, { variant: "caption", color: "text.secondary", sx: { display: "block", textAlign: "center", mt: 1 }, children: ["By adding this player, you confirm you are authorized to enter their information. See our", " ", _jsx(Link, { component: RouterLink, to: "/adding-players", target: "_blank", rel: "noopener", children: "Adding Players" }), " ", "policy."] }));
export const CreateExternalUserAndAddToTeamForm = () => {
    const navigate = useNavigate();
    const { id: teamId } = useNumericParams();
    const { data: permissions, isLoading: permissionsIsLoading, error: permissionsError, } = useRetrieveUserTeamPermissions({ teamId });
    const { canModify = false } = permissions || {};
    const { isLoading: useRetrieveTeamIsLoading, error: useRetrieveTeamError, data: team, } = useRetrieveTeam({ id: teamId, enabled: canModify });
    const createAndAddExternalUserToTeamMutation = useCreateAndAddExternalUserToTeam({
        teamId,
        onMutate: () => { },
        onSuccess: (data) => {
            navigate(`/players/${data.data.id}/`);
        },
        onError: () => { },
    });
    if (permissionsIsLoading) {
        return _jsx(Loading, {});
    }
    if (permissionsError) {
        return _jsx(ErrorView, { error: permissionsError });
    }
    if (!canModify) {
        return _jsx(Forbidden, {});
    }
    if (createAndAddExternalUserToTeamMutation.isLoading ||
        useRetrieveTeamIsLoading) {
        return _jsx(Loading, {});
    }
    if (!team || useRetrieveTeamError) {
        return _jsx(ErrorView, { error: useRetrieveTeamError });
    }
    return (_jsx(OfflinePlayerForm, { title: `Create and Add Player to ${team.name}`, submitLabel: "Create", showSquadNumber: true, defaultValues: {
            externalUser: { firstName: "", lastName: "" },
            player: DEFAULT_PLAYER_METADATA,
            squadNumber: null,
        }, isError: !!createAndAddExternalUserToTeamMutation.isError, errorMessage: "Failed to create player. Please try again.", footer: policyNotice, onSubmit: (data) => createAndAddExternalUserToTeamMutation.mutate(data), onCancel: () => navigate(-1) }));
};
